<template>
  <div class="page mescroll-touch">
    <!-- <img src="../../assets/images/wanshantext.png" alt="" class="wanshantext"> -->

    <div class="item">
      <div class="btitle">选择身份</div>
      <div class="tabrow">
        <div class="tab" :class="{ act: ident == 1 }" @click="hos()">医生</div>
        <div class="tab" :class="{ act: ident == 2 }" @click="hushi()">护士</div>
        <div class="tab" :class="{ act: ident == 3 }" @click="qita()">其他</div>
      </div>
    </div>

    <div class="item" v-if="ident == 1">
      <div class="btitle">个人信息</div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>姓名</div>
        <el-input v-model="name" placeholder="请输入姓名"></el-input>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>手机号</div>
        <el-input v-model="userlist.BaseInfo.Mobile" placeholder="请输入手机号" disabled></el-input>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>医院</div>
        <van-field v-model="hosstr" readonly placeholder="请选择医院" @click="showPopup = true" />
        <van-popup v-model="showPopup" position="bottom">
          <van-cascader v-model="cascaderValue" title="请选择医院" :options="options" :field-names="fieldNames"
            @close="showPopup = false" @finish="onFinish" @change="hoschange" />
        </van-popup>
        <div class="NoHospital" @click="ShowAddHospitalPopup">未找到医院？去新增医院</div>
        <van-popup class="AddHospitalPopup" v-model="ShowAddHospital" :close-on-click-overlay="false">
          <van-icon class="close" name="close" @click="ShowAddHospital = false" />
          <p class="title">新增医院</p>
          <van-field class="AddHospitalInput" v-model="addHospitalArea" readonly placeholder="请选择省市区"
            @click="showAreaPopup = true" />
          <van-field class="AddHospitalInput" v-model="addHospitalName" placeholder="请输入医院名称" />
          <button class="AddHospitalBtn" @click="submitPreHospital">提交</button>
        </van-popup>
        <van-popup v-model="showAreaPopup" round position="bottom" :style="{ height: '40%' }">
          <van-area title="省市区" :area-list="areaList" @cancel="showAreaPopup = false" @confirm="AreaConfirm" />
        </van-popup>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>科室</div>
        <van-field v-model="keshistr" readonly placeholder="请选择科室" @click="showPopup1 = true" />
        <van-popup v-model="showPopup1" position="bottom">
          <van-cascader v-model="cascaderValue1" title="请选择科室" :options="options1" :field-names="fieldNames1"
            @close="showPopup1 = false" @finish="onFinish1" />
        </van-popup>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>职称</div>
        <van-field v-model="zhichengstr" readonly placeholder="请选择职称" @click="showPopup2 = true" />
        <van-popup v-model="showPopup2" position="bottom">
          <van-cascader v-model="cascaderValue2" title="请选择职称" :options="options2" :field-names="fieldNames1"
            @close="showPopup2 = false" @finish="onFinish2" />
        </van-popup>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>执业证书</div>
        <div class="upimgrow">
          <div class="shiyitu">
            <img src="../../assets/images/docimg.png" alt="">
            <div class="syt">示意图</div>
          </div>
          <div class="upimg">
            <van-uploader v-model="imgList" :after-read="afterRead" multiple :max-count="1"
              :upload-icon="require('../../assets/images/ysup.png')" />
          </div>
        </div>
      </div>
    </div>

    <div class="item" v-if="ident == 2">
      <div class="btitle">个人信息</div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>姓名</div>
        <el-input v-model="name" placeholder="请输入姓名"></el-input>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>手机号</div>
        <el-input v-model="userlist.BaseInfo.Mobile" placeholder="请输入手机号" disabled></el-input>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>医院</div>
        <van-field v-model="hosstr" readonly placeholder="请选择医院" @click="showPopup = true" />
        <van-popup v-model="showPopup" position="bottom">
          <van-cascader v-model="cascaderValue" title="请选择医院" :options="options" :field-names="fieldNames"
            @close="showPopup = false" @finish="onFinish" @change="hoschange" />
        </van-popup>
        <div class="NoHospital" @click="ShowAddHospitalPopup">未找到医院？去新增医院</div>
        <van-popup class="AddHospitalPopup" v-model="ShowAddHospital" :close-on-click-overlay="false">
          <van-icon class="close" name="close" @click="ShowAddHospital = false" />
          <p class="title">新增医院</p>
          <van-field class="AddHospitalInput" v-model="addHospitalArea" readonly placeholder="请选择省市区"
            @click="showAreaPopup = true" />
          <van-field class="AddHospitalInput" v-model="addHospitalName" placeholder="请输入医院名称" />
          <button class="AddHospitalBtn" @click="submitPreHospital">提交</button>
        </van-popup>
        <van-popup v-model="showAreaPopup" round position="bottom" :style="{ height: '40%' }">
          <van-area title="省市区" :area-list="areaList" @cancel="showAreaPopup = false" @confirm="AreaConfirm" />
        </van-popup>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>科室</div>
        <van-field v-model="keshistr" readonly placeholder="请选择科室" @click="showPopup1 = true" />
        <van-popup v-model="showPopup1" position="bottom">
          <van-cascader v-model="cascaderValue1" title="请选择科室" :options="options1" :field-names="fieldNames1"
            @close="showPopup1 = false" @finish="onFinish1" />
        </van-popup>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>职称</div>
        <van-field v-model="zhichengstr" readonly placeholder="请选择职称" @click="showPopup2 = true" />
        <van-popup v-model="showPopup2" position="bottom">
          <van-cascader v-model="cascaderValue2" title="请选择职称" :options="options2" :field-names="fieldNames1"
            @close="showPopup2 = false" @finish="onFinish2" />
        </van-popup>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>资格证书</div>
        <div class="upimgrow">
          <div class="shiyitu">
            <img src="../../assets/images/nuimg.png" alt="">
            <div class="syt">示意图</div>
          </div>
          <div class="upimg">
            <van-uploader v-model="imgList" :after-read="afterRead" multiple :max-count="1"
              :upload-icon="require('../../assets/images/hsup.png')" />
          </div>
        </div>
      </div>
    </div>

    <div class="item" v-if="ident == 3">
      <div class="btitle">个人信息</div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>姓名</div>
        <el-input v-model="name" placeholder="请输入姓名"></el-input>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>手机号</div>
        <el-input v-model="userlist.BaseInfo.Mobile" placeholder="请输入手机号" disabled></el-input>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>单位</div>
        <el-input v-model="danwei" placeholder="请输入单位"></el-input>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>职位</div>
        <el-input v-model="zhiwei" placeholder="请输入职位"></el-input>
      </div>
      <div class="innerrow">
        <div class="stitle">备注</div>
        <el-input v-model="beizhu" placeholder="请输入备注"></el-input>
      </div>
      <div class="innerrow">
        <div class="stitle"><span class="red">*</span>身份证正面</div>
        <div class="upimgrow">
          <div class="shiyitu">
            <img src="../../assets/images/qitaimg.png" alt="">
            <div class="syt">示意图</div>
          </div>
          <div class="upimg">
            <van-uploader v-model="imgList" :after-read="afterRead" multiple :max-count="1"
              :upload-icon="require('../../assets/images/qtup.png')" />
          </div>
        </div>
      </div>
    </div>
    <button class="login" @click="login()">提交</button>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
import { Dialog } from 'vant';
// import storage from "../../common/utils/storage";
import { areaList } from '@vant/area-data';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  name: 'compinfo',
  data() {
    return {
      ident: 1,
      name: "",
      phone: "",
      showPopup: false,
      showPopup1: false,
      showPopup2: false,
      list1: [],
      fileUrl: "",
      hosstr: "",
      keshistr: "",
      zhichengstr: "",
      cascaderValue: '',
      cascaderValue1: '',
      cascaderValue2: '',
      imgList: [],
      fieldNames: {
        text: 'name',
        value: 'code',
        children: 'items',
      },
      fieldNames1: {
        text: 'Name',
        value: 'Name',
        children: 'Items',
      },
      options: [],
      // options1: [],
      options1: [
        {
          Code: "皮肤性病科",
          Name: "皮肤性病科",
        },
        {
          Code: "医疗美容科",
          Name: "医疗美容科",
        },
        {
          Code: "整形外科",
          Name: "整形外科",
        },
        {
          Code: "中医科",
          Name: "中医科",
        },
        {
          Code: "中西医结合科",
          Name: "中西医结合科",
        },
        {
          Code: "其他科室/部门",
          Name: "其他科室/部门",
        },
      ],
      options2: [],
      danwei: "",
      zhiwei: "",
      beizhu: "",
      userlist: {
        BaseInfo: {}
      },
      ShowAddHospital: false,
      addHospitalArea: '',
      addHospitalName: '',
      showAreaPopup: false,
      areaList: areaList
    }
  },
  computed: {
    // ...mapState(['Openid', 'userInfo']),
    sid() {
      return this.$route.query.sid;
    },
    uri() {
      return this.$route.query.uri;
    }
  },
  mounted() {
    // this.gethos();
  },
  created() {
    document.title = "华肤荟";
    let municipalitys = ['北京市', '天津市', '上海市', '重庆市'];
    for (let key in areaList.city_list) {
      if (municipalitys.includes(areaList.city_list[key])) {
        areaList.city_list[key] = '市辖区';
      }
    }

    // this.$nextTick(() => {
    this.gethos();
    // this.getkeshi();
    this.getzhicheng();
    this.getinfo()
    // });
  },
  methods: {
    getinfo() {
      this.$axios.get('/api/api/web/Customer/GetMyInfo').then(res => {
        console.log(res)
        this.userlist = res.Data;
        if (this.userlist.BaseInfo != null) {
          if (this.userlist.BaseInfo.RegistType == 10) {
            this.ident = 1
            this.name = this.userlist.BaseInfo.RealName;
            this.hosstr = this.userlist.BaseInfo.Hospital
            this.keshistr = this.userlist.BaseInfo.HospitalDepartment
            this.zhichengstr = this.userlist.BaseInfo.HospitalJobTitle
          } else if (this.userlist.BaseInfo.RegistType == 20) {
            this.ident = 2
            this.name = this.userlist.BaseInfo.RealName;
            this.hosstr = this.userlist.BaseInfo.Hospital
            this.keshistr = this.userlist.BaseInfo.HospitalDepartment
            this.zhichengstr = this.userlist.BaseInfo.HospitalJobTitle
          } else {
            this.ident = 3
            this.name = this.userlist.BaseInfo.RealName;
            this.danwei = this.userlist.BaseInfo.Company
            this.zhiwei = this.userlist.BaseInfo.CompanyJobTitle
            this.beizhu = this.userlist.BaseInfo.CompanyNotes
          }
        }
      })
    },
    gethos() {
      this.options = [];
      this.$axios.post('/api/api/web/Customer/GetProvince').then(res => {
        // console.log(res.Data);
        for (var i = 0; i < res.Data.length; i++) {
          // console.log(res.Data[i])
          this.options.push({
            name: res.Data[i],
            code: res.Data[i],
            items: [],
            type: 'Province',
          })
        }
        console.log(this.options)
      })
    },
    // getkeshi() {
    //   this.options1 = [];
    //   this.$axios.get('/api/api/web/Customer/GetDepartment').then(res => {
    //     this.options1 = res.Data
    //   })
    // },
    getzhicheng() {
      this.options2 = [];
      this.$axios.get('/api/api/web/Customer/GetJobTitle').then(res => {
        this.options2 = res.Data
      })
    },
    hoschange(tabIndex) {
      let that = this;
      console.log(tabIndex)
      if (tabIndex.selectedOptions.length == 1 && tabIndex.selectedOptions[0].type == "Province") {
        this.$axios.post('/api/api/web/Customer/GetCity', {
          Province: tabIndex.value
        }).then(res => {
          let t = that.options.find(f => f.name == tabIndex.value); if (t) {
            t.items = [];
          }
          // console.log(res.Data);
          for (var i = 0; i < res.Data.length; i++) {
            // console.log(res.Data[i])
            for (var o = 0; o < that.options.length; o++) {
              if (that.options[o].name == tabIndex.value) {
                // console.log(that.options[o].name)
                that.options[o].items.push({
                  name: res.Data[i],
                  code: res.Data[i],
                  items: [],
                  type: "City"
                })
              }
              // console.log(this.options)
            }
          }
        })
      } else if (tabIndex.selectedOptions.length == 2 && tabIndex.selectedOptions[1].type == "City") {
        this.$axios.post('/api/api/web/Customer/GetArea', {
          Province: tabIndex.selectedOptions[0].name,
          City: tabIndex.selectedOptions[1].code,
        }).then(res => {
          // console.log(res.Data);
          for (var x = 0; x < that.options.length; x++) {
            let t = that.options[x].items.find(f => f.name == tabIndex.selectedOptions[1].code);
            if (t) {
              t.items = [];
            }
          }
          for (var i = 0; i < res.Data.length; i++) {
            for (var o = 0; o < that.options.length; o++) {
              for (var a = 0; a < that.options[o].items.length; a++) {
                if (that.options[o].name == tabIndex.selectedOptions[0].name && that.options[o].items[a].name == tabIndex.selectedOptions[1].name) {
                  that.options[o].items[a].items.push({
                    name: res.Data[i],
                    code: res.Data[i],
                    items: [],
                    type: "Area"
                  })
                }
              }
            }
          }
        })
      } else if (tabIndex.selectedOptions.length == 3 && tabIndex.selectedOptions[2].type == "Area") {
        this.$axios.post('/api/api/web/Customer/GetHospitial', {
          Province: tabIndex.selectedOptions[0].name,
          City: tabIndex.selectedOptions[1].code,
          Area: tabIndex.selectedOptions[2].code,
        }).then(res => {
          for (var x = 0; x < that.options.length; x++) {
            for (var y = 0; y < that.options[x].items.length; y++) {
              let t = that.options[x].items[y].items.find(f => f.name == tabIndex.selectedOptions[2].code);
              if (t) {
                t.items = [];
              }
            }
          }
          // console.log(res.Data);
          for (var i = 0; i < res.Data.length; i++) {
            // console.log(res.Data[i])
            for (var o = 0; o < that.options.length; o++) {
              for (var a = 0; a < that.options[o].items.length; a++)
                for (var b = 0; b < that.options[o].items[a].items.length; b++)
                  if (that.options[o].name == tabIndex.selectedOptions[0].name && that.options[o].items[a].name == tabIndex.selectedOptions[1].name && that.options[o].items[a].items[b].name == tabIndex.selectedOptions[2].name) {
                    that.options[o].items[a].items[b].items.push({
                      name: res.Data[i],
                      code: res.Data[i],
                      type: "Hospitial"
                    })
                  }
            }
          }
        })
      }
    },
    onFinish({ selectedOptions }) {
      this.showPopup = false;
      // console.log(selectedOptions.map((option) => option.name).join('/'))
      this.hosstr = selectedOptions.map((option) => option.name).join('/');
      // console.log(this.hosstr)
    },
    onFinish1({ selectedOptions }) {
      this.showPopup1 = false;
      // console.log(selectedOptions.map((option) => option.name).join('/'))
      this.keshistr = selectedOptions.map((option1) => option1.Name).join('/');
      // console.log(this.hosstr)
    },
    onFinish2({ selectedOptions }) {
      this.showPopup2 = false;
      // console.log(selectedOptions.map((option) => option.name).join('/'))
      this.zhichengstr = selectedOptions.map((option2) => option2.Name).join('/');
      // console.log(this.hosstr)
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      const formData = new FormData();
      formData.append("file", file.file);
      this.$axios
        .post("/api/api/web/ImgFile/UploadImg", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.RetCode == 10000) {
            this.fileUrl = res.Data.Url;
          }
        });
    },
    hos() {
      this.ident = 1
      this.hosstr = "";
      this.keshistr = "";
      this.zhichengstr = "";
      this.danwei = "";
      this.zhiwei = "";
      this.beizhu = "";
    },
    hushi() {
      this.ident = 2
      this.hosstr = "";
      this.keshistr = "";
      this.zhichengstr = "";
      this.danwei = "";
      this.zhiwei = "";
      this.beizhu = "";
    },
    qita() {
      this.ident = 3
      this.hosstr = "";
      this.keshistr = "";
      this.zhichengstr = "";
      this.danwei = "";
      this.zhiwei = "";
      this.beizhu = "";
    },
    ShowAddHospitalPopup() {
      this.addHospitalArea = '';
      this.addHospitalName = '';
      this.ShowAddHospital = true;
    },
    AreaConfirm(value) {
      this.addHospitalArea = value[0].name + '/' + value[1].name + '/' + value[2].name;
      this.showAreaPopup = false;
    },
    submitPreHospital() {
      if (!this.addHospitalArea) {
        this.$toast('请选择省市区！');
        return false;
      }
      if (!this.addHospitalName) {
        this.$toast('请输入医院名称！');
        return false;
      }

      let areas = this.addHospitalArea.split("/");
      let param = {
        Province: areas[0],
        City: areas[1],
        Area: areas[2],
        Name: this.addHospitalName,
      }
      let url = "/api/api/web/Customer/PreAddHospital";
      this.$axios.post(url, param).then(res => {
        this.$toast({
          type: 'success',
          message: '新增成功',
          duration: 1000,
          onClose: () => {
            this.hosstr = this.addHospitalArea + '/' + this.addHospitalName;
            this.ShowAddHospital = false;
          }
        });
      })
    },
    login() {
      let idt = "";
      let upload = {}
      if (this.ident == 1) {
        upload = {
          CustomerType: 10,
          Name: this.name,
          Company: this.hosstr,
          Department: this.keshistr,
          JobTitle: this.zhichengstr,
          Credentials1: this.fileUrl
        };
      }
      if (this.ident == 2) {
        upload = {
          CustomerType: 20,
          Name: this.name,
          Company: this.hosstr,
          Department: this.keshistr,
          JobTitle: this.zhichengstr,
          Credentials1: this.fileUrl
        };
      }
      if (this.ident == 3) {
        upload = {
          CustomerType: 30,
          Name: this.name,
          Company: this.danwei,
          Description: this.beizhu,
          JobTitle: this.zhiwei,
          Credentials1: this.fileUrl
        };
      }
      if (!upload.Name) {
        Dialog.alert({
          message: '请输入姓名',
        }).then(() => {
        });
        return false;
      }
      if (this.ident == 1 || this.ident == 2) {
        if (!upload.Company) {
          Dialog.alert({
            message: '请选择医院',
          }).then(() => {
          });
          return false;
        }
        if (!upload.Department) {
          Dialog.alert({
            message: '请选择科室',
          }).then(() => {
          });
          return false;
        }
        if (!upload.JobTitle) {
          Dialog.alert({
            message: '请选择职称',
          }).then(() => {
          });
          return false;
        }
        if (!upload.Credentials1) {
          Dialog.alert({
            message: '请上传证明材料',
          }).then(() => {
          });
          return false;
        }
      } else if (this.ident == 3) {
        if (!upload.Company) {
          Dialog.alert({
            message: '请输入单位',
          }).then(() => {
          });
          return false;
        }
        if (!upload.JobTitle) {
          Dialog.alert({
            message: '请输入职务',
          }).then(() => {
          });
          return false;
        }
        if (!upload.Credentials1) {
          Dialog.alert({
            message: '请上传证明材料',
          }).then(() => {
          });
          return false;
        }
      }
      // console.log(upload)
      if (this.userlist.OldUser != null) {
        this.$axios.post('/api/api/web/Customer/HFHIdentitySubmit', upload).then(res => {
          // console.log(res)
          // this.userlist = res.Data;
          Dialog.alert({
            message: '提交成功！',
          }).then(() => {
            this.$router.push({
              path: 'mine',
            });
          });
        })
      } else {
        this.$axios.post('/api/api/web/Customer/HFHIdentitySubmit', upload).then(res => {
          // console.log(res)
          // this.userlist = res.Data;
          Dialog.alert({
            message: '提交成功！',
          }).then(() => {
            this.$router.push({
              path: 'mine',
            });
          });
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  background: linear-gradient(180deg, #E4E8FA 0%, #F7F8FC 97%);
  width: 100%;
  min-height: 100%;
  padding: .5rem 5%;
  box-sizing: border-box;
}

.wanshantext {
  display: block;
  width: 80%;
  margin: 0.6rem auto;
  margin-bottom: 1rem;
}

.item {
  background: #fff;
  padding: 0.3rem 0.3rem;
  margin-bottom: 0.5rem;
  box-sizing: border-box;
}

.btitle {
  font-size: 18px;
  color: #0C2941;
  font-weight: 600;
  margin-bottom: .5rem
}

.tabrow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
}

.tab {
  width: 30%;
  background: #F5F6FA;
  padding: 0.4rem 0;
  border-radius: 4px;
}

.act {
  background: #6F82CA;
  color: #fff;
}

.stitle {
  margin-bottom: .3rem;
  font-size: 14px;
  font-weight: 600;
  color: #0C2941;
}

.red {
  color: #FA5151;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0.1rem;
}

.innerrow {
  margin-bottom: .3rem;
}

.van-button {
  width: 100%;
  border-radius: 4px;
  background: #fff;
  color: #000;
  text-align: left;
  border: 1px solid #DCDFE6;
}

.van-button__content {
  justify-content: left;
}

.van-cell {
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}

.login {
  margin: auto;
  margin-top: 1rem;
  display: block;
  width: 90%;
  padding: 0.3rem 0;
  font-size: .43rem;
  border: 0;
  background: #1d2a5a;
  color: #fff;
  border-radius: 50px;
}

.NoHospital {
  font-size: 10px;
  color: #FA5151;
  text-decoration: underline;
  margin-top: 5px;
}

.AddHospitalPopup {
  width: 80%;
  padding: 15px 20px;
  border-radius: 6px;
  background-color: #FFFFFF;

  .close {
    position: absolute;
    top: 6px;
    right: 6px;
    font-size: 20px;
  }

  .title {
    font-size: 16px;
    text-align: center;
    font-weight: bold;
  }

  .AddHospitalInput {
    margin-top: 20px;
  }

  .AddHospitalBtn {
    margin: 20px auto 0;
    display: block;
    width: 100px;
    height: 40px;
    font-size: 14px;
    border: 0;
    background: #1d2a5a;
    color: #fff;
    border-radius: 40px;
  }
}

.upimgrow {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.shiyitu {
  width: 42%;
  text-align: center;

  img {
    width: 100%;
    display: block;
  }
}

.upimg {
  width: 42%;
  text-align: center;
}

::v-deep .van-icon__image {
  width: 100% !important;
  height: 100% !important;
}

::v-deep .van-uploader {
  width: 100%;
}

::v-deep .van-uploader__upload {
  width: 100%;
  height: auto;
  margin: 0;
}

::v-deep .van-uploader__preview {
  width: 100%;
  height: auto;
  margin: 0;
}

::v-deep .van-uploader__preview-image {
  width: 100%;
  height: auto;
}

.syt {
  margin-top: 0.2rem;
  font-size: .35rem;
}
</style>